import ApiService from '@/common/api.service'

const DAYS_IN_ADVANCE = 4

const state = {
  menu: {},
  days: {},
  builder: {},
  products: []
}

const getters = {
  menu: (state) => state.menu,
  days: (state) => state.days,
  builder: (state) => state.builder,
  products: (state) => state.products,
}

const actions = {
  /**
   * get menu for today
   * 
   */
  getProducts: (context) => {
    context.commit('general/app_loading_message', 'Loading products', { root: true })
    return new Promise((resolve, reject) => {
      ApiService.get('pos/menu', {
        params: {
          include: 'category.product.alergens,product.companies'
        }
      })
      .then((result) => {
        context.commit('general/app_loading_message', null, { root: true })
        let unique_categories_ids = []
        let menu = {}
        context.commit('products/products', result.data.data, { root: true })
        result.data.data.forEach(item => {
          if (unique_categories_ids.indexOf(item.category_id) == -1) {
            unique_categories_ids.push(item.category_id)
            menu[item.category_id] = {
              category: item.category,
              products: {}
            }
          }
          menu[item.category_id].products[item.product_id] = item.product.data
        });

        vm.$db.setProducts(result.data.data)
        context.commit('products/menu', menu, { root: true })
        resolve()
      })
      .catch(error => {
        let menu = vm.$db.getMenu()
        let products = vm.$db.getProducts()

        Promise.all([menu, products]).then(function([menu, products]) {
          context.commit('products/menu', menu, { root: true })
          context.commit('products/products', products, { root: true })
          resolve()
        }).catch(function(err) {
          console.error(err);
          reject()
        });
      })
    }); 
  },

  getMenus: (context) => {
    context.commit('general/app_loading_message', 'Loading menus', { root: true })
    return new Promise((resolve, reject) => {
      // generate the DAYS_IN_ADVANCE + 1(today) day slots
      let days = {}
      let today = moment()
      let range = moment.rangeFromInterval('day', DAYS_IN_ADVANCE, moment());
      for (let day of range.by('day')) {
        days[day.format('YYYY-MM-DD')] = null;
      }
      ApiService.get('employee/order/days').then((result) => {
        result.data.days.forEach(day => {
          days[day.day] = day
        })
        context.commit('products/days', days, { root: true })
        resolve()   
      }).catch(err => {
        console.error(err);
        reject()
      })
    })
  },

  getMenu: (context, day) => {
    context.commit('general/app_loading_message', 'Loading menus', { root: true })
    return new Promise((resolve, reject) => {
      ApiService.get(`employee/order/day/${day}/products`).then((result) => {
        let menu = {}
        let unique_categories_ids = []
        result.data.data.forEach(item => {
          if (unique_categories_ids.indexOf(item.category_id) == -1) {
            unique_categories_ids.push(item.category_id)
            menu[item.category_id] = {
              category: item.category,
              products: {}
            }
          }
          menu[item.category_id].products[item.product_id] = item.product.data
        });
        context.commit('products/menu', menu, { root: true })
        resolve(menu)   
      }).catch(err => {
        console.error(err);
        reject()
      })
    })
  },

  /**
   * get daily menus
   * 
   */
  /*
   * DEPRECATED
   * 
   getMenus: (context, week) => {
    context.commit('general/app_loading_message', 'Loading menus', { root: true })
    return new Promise((resolve, reject) => {
      ApiService.get('employee/order/days').then((result) => { // web/menu
        let menu = {}
        console.log(result)
        // extract menus by days and categories
        // group menu first by day
        let days = _.groupBy(result.data.data, item => {
          let d = moment(item.day.date)
          return d.format('YYYY-MM-DD') 
        })
        
        // then group menu by category
        // for each menu day
        Object.keys(days).forEach(day => {
          let unique_categories_ids = []
          let day_menu = {}
          let day_items = days[day]
          // iterate all menu products for that day
          day_items.forEach(item => {
            if (unique_categories_ids.indexOf(item.category_id) == -1) {
              unique_categories_ids.push(item.category_id)
              day_menu[item.category_id] = {
                category: item.category,
                products: {}
              }
            }
            day_menu[item.category_id].products[item.product_id] = item.product.data
          })
          menu[day] = day_menu
        })
        context.commit('products/menu', menu, { root: true })
        resolve()        
      }).catch(err => {
        console.error(err);
        reject()
      })
    }); 
  },
  */

  createBuilder: (context, payload) => {
    var builder = {}
    var product = payload.product
    var category = payload.category

    if (product.configurations.length == 0) return

    builder.product = product
    builder.category = category
    builder.categories = {}
    product.configurations.data.forEach(category => {
      builder.categories[category.id] = category
      builder.categories[category.id].product = null
    })

    context.commit('products/builder', builder, { root: true })
  },

}

const mutations = {
  ['menu']: (state, menu) => {
    state.menu = menu
  },
  ['days']: (state, days) => {
    state.days = days
  },
  ['builder']: (state, builder) => {
    state.builder = builder
  },
  ['builder_update']: (state, payload) => {
    state.builder.categories[payload.category.id].product = payload.product
  },
  ['builder_clean']: (state) => {
    state.builder = {}
  },
  ['products']: (state, products) => {
    state.products = products
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
